export * from './auth-domain.error';
